/*************************************************/
/* MMENU                                         */
/*************************************************/
import Mmenu from 'mmenu-js';

export function mmenu() {
    let mobileMenu,
        mobileMenuTrigger,
        breakpointMaxM = 768,
        resizeTimer;

        const mobileMenuSelector = '#mobile-menu',
        mainContentSelector = '#mainContent';

    const init = function () {
        mobileMenu = document.querySelector(mobileMenuSelector);
        mobileMenuTrigger = document.querySelector('.mm-trigger');
        breakpointMaxM = 768;

        const menu = new Mmenu(mobileMenuSelector, {
            // options
            'extensions': [
                'position-right',
                'pagedim-black',
                'border-full',
                'theme-dark',
                'fx-menu-slide',
                'custom-width'
            ],
            'navbar': {
                add:false
            }
        }, {
            // configuration
            offCanvas: {
                page: {
                    nodetype: 'main',
                    selector:mainContentSelector
                }
            },
            classNames: {
                selected: 'custom-mm-selected',
                panel: 'custom-mm-panel',
            }
        });

        // Init mmenu api
        const mmenuApi = menu.API;

        // Open menu
        mobileMenuTrigger.addEventListener('click', () => {
            if (mmenuApi) {
                mobileMenu.setAttribute('style', '');
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpointMaxM (768px)
        window.addEventListener('resize', e => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                const width = document.body.clientWidth;
                const mmIsOpened = document.querySelector('body').classList.contains('mm-wrapper_opening');
                if (mmenuApi && mmIsOpened && width > breakpointMaxM) {
                    mmenuApi.close();
                }
            }, 250);
        });
    };

    init();
}
